import 'intl-pluralrules';
import './index.css';

import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '../../src/app/app';

const el = document.getElementById('root');

if (!el) {
	throw new Error('Root element not found');
}

createRoot(el).render(
	<StrictMode>
		<Suspense>
			<App />
		</Suspense>
	</StrictMode>
);
